import React, { useState, useEffect, useRef } from 'react';
import '@expo/match-media'
import { useMediaQuery } from "react-responsive";
import { SpringGrid } from 'react-stonecutter';
import { Platform, View, Dimensions } from 'react-native';
import { Overlay, Image } from 'react-native-elements';
import Page from './page'
import OverlayWeb from '../web/Overlay';
import Settings from '../settings'
import { url } from '../../libs/fetch'
import background from '../../images/background-slot.jpg'
import SlotGame from '../slot-game-2';
import logo from '../../images/minilogo-slot.png'
import slotsVendors from '../../libs/slots-vendors';
import Loading from '../loading';
import moment from 'moment'

const noPackage = (pname, pexpire) => {
  switch(pname.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }


  if (!pexpire) {
    throw new Error('No package expire date')
  }

  return moment(pexpire).isBefore(moment())
}


const convertData = (d) => {
  if (d.perc) {
      return d;
  }

  if (d.v && d.n) {
      return {
          name: d.n, 
          img: { name: d.n, img: d.i }, 
          perc: d.p, 
          vendor: d.v,
          $: 'v2',
      }
  }
}

const configs = {
  sa: { image_ratio: 0.5, columns: [1, 1, 2, 3] , name: "SA Gaming", circle_ratio: 0.7, banner: "https://kickoffbet989.com/wp-content/uploads/2020/05/sagaming.jpg" },
  joker: { image_ratio: 1, columns: [1, 2, 3, 4], name: "JOKER", circle_ratio: 0.4, banner: "https://i.pinimg.com/originals/e9/bc/01/e9bc01bdb457bd5059bf4795e76711f0.png" },
  spade: { image_ratio: 1, columns: [1, 2, 3, 4], name: "SPADE", circle_ratio: 0.4, banner: "https://ufabets24.com/wp-content/uploads/2019/11/Spadegaming.jpg" },
  default: { image_ratio: 1, columns: [1, 2, 3, 4], circle_ratio: 0.4 },
}

export default ({ token, subscription, subscription_expire, onChooseGame, vendor = 'spade' }) => {

    const ws = useRef(null);
    const [popup, setPopup] = useState(false);
    const [games, setGames] = useState([]);
    const [winSize, setWinSize] = useState(Math.min(1024, Dimensions.get('window').width));

    const vendorData = slotsVendors.filter(v => v.code === vendor).pop() || {};

    const config = configs[vendor] || configs['default']
    const banner = vendorData.img || config.banner
    const name = vendorData.name || config.name
    console.log('VVV', vendor, vendorData, banner, config, slotsVendors)

    const isMobile380 = useMediaQuery({
        query: "(max-width: 380px)"
    });
    const isMobile480 = useMediaQuery({
        query: "(max-width: 480px)"
    });
    const isMobile600 = useMediaQuery({
        query: "(max-width: 600px)"
    }); 

    let columns = config.columns[3]
    switch(true) {
        case isMobile380: columns = config.columns[0]; break;
        case isMobile480: columns = config.columns[1]; break;
        case isMobile600: columns = config.columns[2]; break;
    }
 
    const connect = (dbg) => {
        console.log('COnnect on ', dbg)
        ws.current = new WebSocket(url(`/slotz/ws/`).replace(/^http/, 'ws'));
        ws.current.onopen = function() {
          console.log("OPEN", dbg)
          ws.current.send(JSON.stringify({
              token: token,
              vendor: vendor,
          }));
        };
      
        ws.current.onmessage = function(e) {
          const data = JSON.parse(e.data)
          //console.log('Message:', data, games.length, refGames.current.length);
          // if (refGames.current.length) return;
          setGames(data.map(convertData))
        };
      
        ws.current.onclose = function(e) {
          console.log('Socket is closed. Reconnect will be attempted in 3 second.', e.reason, dbg);
          
          if (ws.current) {
            try{  ws.current.close(); } catch(err) { console.log('onclose->close failed' ,err) }
            try{  ws.current && ws.current.terminate && ws.current.terminate(); } catch(err) { console.log('onerror->terminate failed' ,err) }
            ws.current = null
          }
          
           setTimeout(function() {
             connect('onClose' + Math.random());
           }, 5000);

        };
      
        ws.current.onerror = function(err) {
          console.error('Socket encountered error: ', err, 'Closing socket', dbg);
          try{  ws.current.close(); } catch(err) { console.log('onerror->close failed' ,err) }
          try{  ws.current && ws.current.terminate && ws.current.terminate(); } catch(err) { console.log('onerror->terminate failed' ,err) }
          ws.current = null
          // setTimeout(function() {
          //   connect('onEror' + Math.random());
          // }, 10000);
        };
    }

    useEffect(() => {
        connect('0')
        // if (Platform.OS === 'web') {
        //       window.addEventListener('resize', () => {
        //         // setWinSize(Math.min(1024, Dimensions.get('window').width))
        //         setWinSize(Math.min(1024, window.innerWidth))
        //       });
        // };
    }, [])

    const Overlayer = Platform.OS === 'web' ? OverlayWeb : Overlay;

    // console.log('RENDER', columns, winSize, games)

    return <Page 
        onSetting={() => { setPopup( true ) }}
        background={background}
        title={`สูตรสล๊อต`}
        subtitle={name || vendor.toUpperCase()}
        logo={logo}
        onClickLogo={onChooseGame}
    >
        <View style={{  alignItems: 'center', margin: 20 }}>
          <Image
            source={{ uri: banner }}
            style={{ width: 180, height: 90 }}
            resizeMode="contain"
            placeholderStyle={{ backgroundColor: '#000000' }}
          />
        </View>
        <View style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                alignContent: 'center',
                justifyContent: 'center',
                flexGrow: 1,
                flexWrap: 'wrap'
            }}>
          {games.length <= 0 ? <Loading /> : null}
          {games.map((g, idx) => (
              <div key={g.name}>
                <SlotGame
                  imageRatio={config.image_ratio}
                  circleRatio={config.circle_ratio}
                  blocked={noPackage(subscription, subscription_expire) && idx > 3}
                  gid={g.name}
                  perc={g.perc}
                  name={g.name}
                  img={g.img.img}
                  animationStyle={{}}
                  width={winSize/columns}

                  openSetting={() => {
                    setPopup(true)
                  }}
                />
              </div>
          ))}
        </View>


        {/*<SpringGrid
          component={View}
          columns={columns}
          columnWidth={winSize/columns}
          gutterWidth={0}
          gutterHeight={20}
          itemHeight={winSize/columns * config.image_ratio}
          springConfig={{ stiffness: 170, damping: 26 }}
        >
          {games.map((g, idx) => (
              <div key={g.name}>
                <SlotGame
                  imageRatio={config.image_ratio}
                  circleRatio={config.circle_ratio}
                  blocked={noPackage(subscription, subscription_expire) && idx > 3}
                  gid={g.name}
                  perc={g.perc}
                  name={g.name}
                  img={g.img.img}
                  animationStyle={{}}
                  width={winSize/columns}

                  openSetting={() => {
                    setPopup(true)
                  }}
                />
              </div>
          ))}
                </SpringGrid>*/}
        <Overlayer
            key='overlay'
            isVisible={popup}
            windowBackgroundColor="rgba(0, 0, 0, .5)"
            onBackdropPress={() => {}}
            overlayBackgroundColor="#ffffff"
            // overlayStyle={{backgroundColor: '#ffffff', borderRadius: 10}}
        >
            <Settings close={() => setPopup(false)} openSA={() => { setPopup(false); setPopupSA( true ) }}/>
        </Overlayer>
    </Page>
}

/*
        

*/

